module.exports = __webpack_public_path__ + "static/img/njTitle.01eae4bf.png";